/* eslint-disable */
export default {
  close: 'Sluiten',
} as const;

// @key: @#@"close"@#@ @source: @#@"Close"@#@
